/**
 * Main JavaScript entry point.
 *
 * Bundled by Laravel Mix / Webpack.
 * jQuery and Popper are excluded from the bundle (loaded by WordPress / enqueue.php).
 */

require( './bootstrap4/bootstrap' );
require( './skip-link-focus-fix' );
require( './custom-javascript' );
